import { VOLOP_SOURCES } from './volopSources';

export const VOLOP_SOURCE_FOR_ACTION_TYPE = {
  NONE: [...Object.keys(VOLOP_SOURCES)],
  VOLOP: [
    'NONE',
    'IDEALIST',
    'VOLUNTEERMATCH',
    'POINTS_OF_LIGHT',
    'AARP',
    'DO_SOMETHING',
    'NEWYORKCARES',
    'VOLUNTEERGOV',
  ],
  EVENT: ['NONE', 'IDEALIST', 'NYCPARKS', 'CITIZENCONNECT'],
  LOAN: ['KIVA'],
  DONATION: ['NONE', 'DONORS_CHOOSE', 'GLOBAL_GIVING', 'DO_SOMETHING'],
  OTHER: ['IDEALIST', 'DO_SOMETHING'],
  PETITION: ['MOVE_ON', 'DO_SOMETHING', 'CARE2'],
};
